import dispatcher from '../dispatchers/dispatcher';

export function getArticles(hardRefresh) {
    if (hardRefresh) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', 'http://www.wblocks.com/hondaAPI/items/all', true);
        xhr.onreadystatechange = function () {
            if (xhr.readyState == 4) {
                if (xhr.status === 200) {
                    var data = eval('(' + xhr.response + ')');
                    dispatcher.dispatch({
                        type: 'GET_ARTICLES',
                        articles: data.success.body.items
                    });
                } else if (xhr.status === 0) {
                    dispatcher.dispatch({
                        type: 'NO_NETWORK_CONNECTION'
                    });
                }
            }
        }
        xhr.send();
    }
}

export function getArticlesByBrand(brandId) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', 'http://www.wblocks.com/hondaAPI/items/brand/' + brandId, true);
    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
            if (xhr.status === 200) {
                var data = eval('(' + xhr.response + ')');
                dispatcher.dispatch({
                    type: 'GET_ARTICLES',
                    articles: data.success.body.items
                });
            } else if (xhr.status === 0) {
                dispatcher.dispatch({
                    type: 'NO_NETWORK_CONNECTION'
                });
            }
        }
    }
    xhr.send();
}

export function getArticlesByCategories(categoryId) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', 'http://www.wblocks.com/hondaAPI/items/category/' + categoryId, true);
    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
            if (xhr.status === 200) {
                var data = eval('(' + xhr.response + ')');
                dispatcher.dispatch({
                    type: 'GET_ARTICLES',
                    articles: data.success.body.items
                });
            } else if (xhr.status === 0) {
                dispatcher.dispatch({
                    type: 'NO_NETWORK_CONNECTION'
                });
            }
        }
    }
    xhr.send();
}

export function getArticlesByCategorieAndBrand(categoryId, brandId) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', 'http://www.wblocks.com/hondaAPI/items/categoryandbrand/' + categoryId + '/' + brandId, true);
    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
            if (xhr.status === 200) {
                var data = eval('(' + xhr.response + ')');
                dispatcher.dispatch({
                    type: 'GET_ARTICLES',
                    articles: data.success.body.items
                });
            } else if (xhr.status === 0) {
                dispatcher.dispatch({
                    type: 'NO_NETWORK_CONNECTION'
                });
            }
        }
    }
    xhr.send();
}

export function increaseStatistics(articleId, type) {
    var xhr = new XMLHttpRequest();
    let params = 'action=increaseStatistics&id=' + articleId + '&type=' + type;

    xhr.open('POST', 'http://www.wblocks.com/hondaAPI/items/statistics/increase', true);

    xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
            if (xhr.status === 200) {
                //var data = eval('(' + xhr.response + ')');
            } else if (xhr.status === 0) {
                dispatcher.dispatch({
                    type: 'NO_NETWORK_CONNECTION'
                });
            }
        }
    }
    xhr.send(params);
}

export function createNotification(brandId, articleId) {
    var xhr = new XMLHttpRequest();
    let params = 'action=newNotification&brandId=' + brandId + '&itemId=' + articleId;

    xhr.open('POST', 'http://www.wblocks.com/hondaAPI/notifications/create', true);

    xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
            if (xhr.status === 200) {
                //var data = eval('(' + xhr.response + ')');
            } else if (xhr.status === 0) {
                dispatcher.dispatch({
                    type: 'NO_NETWORK_CONNECTION'
                });
            }
        }
    }
    xhr.send(params);
}

export function getCategories() {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', 'http://www.wblocks.com/hondaAPI/categories/all', true);
    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
            if (xhr.status === 200) {
                var data = eval('(' + xhr.response + ')');
                dispatcher.dispatch({
                    type: 'GET_CATEGORIES',
                    categories: data.success.body.categories
                });
            } else if (xhr.status === 0) {
                dispatcher.dispatch({
                    type: 'NO_NETWORK_CONNECTION'
                });
            }
        }
    }
    xhr.send();
}

export function getBrands() {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', 'http://www.wblocks.com/hondaAPI/brands/all', true);
    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
            if (xhr.status === 200) {
                var data = eval('(' + xhr.response + ')');
                dispatcher.dispatch({
                    type: 'GET_BRANDS',
                    brands: data.success.body.brands
                });
            } else if (xhr.status === 0) {
                dispatcher.dispatch({
                    type: 'NO_NETWORK_CONNECTION'
                });
            }
        }
    }
    xhr.send();
}

export function sendPromo(userName, email, articleName, callback) {
    var xhr = new XMLHttpRequest();
    let params = 'name='+userName+'&email=' + email + '&articleName=' + articleName;

    xhr.open('POST', 'http://www.wblocks.com/hondaAPI/promo/send/mail', true);

    xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
            if (xhr.status === 200) {                
                callback();
            } else if (xhr.status === 0) {
                dispatcher.dispatch({
                    type: 'NO_NETWORK_CONNECTION'
                });
            }
        }
    }
    xhr.send(params);
}


// WEBPACK FOOTER //
// ./src/actions/TotemActions.js